<template>
  <div>
    <nuxt-link v-for="{ title, text } in navigation" :key="title" :to="localePath(text) || ''" class="link">
      {{ title }}
    </nuxt-link>
  </div>
</template>

<script>
export default {
  computed: {
    navigation() {
      const key = 'header.navigation-list';
      const exist = this.$te(key);
      const links = exist ? this.$t(key) : [];

      return links.concat({
        text: 'complains',
        title: this.$t('contacts-page.email-complains-title'),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.link {
  font-size: 14px;
  color: map-get($colors, gray);
  letter-spacing: -2%;

  @include not-desktop {
    margin-bottom: 30px;
    display: block;
    font-weight: 600;
  }

  @include desktop {
    margin-top: 3px;
    font-weight: 400;
  }

  &:after {
    display: block;
    width: 100%;
    height: 2px;
    background: map-get($colors, secondary);
    transform: scaleX(0);
    transform-origin: left;
    transition: all 0.3s;
    margin-top: 2px;

    @include desktop {
      content: '';
    }
  }

  &.active-url {
    color: map-get($colors, gray-darker);
    font-weight: 700;

    &:after {
      transform: scaleX(1);
      color: map-get($colors, black);
    }
  }

  &:hover {
    text-decoration: none;

    &:after {
      transform: scaleX(1);
    }
  }
}
</style>
